import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import styled from "styled-components";
import imgWhatsApp from "../assets/whatsapp.svg";

const BtnContactWhatsAppFloating = () => {
  const encodedMessage = encodeURIComponent(`Hola tengo una duda con el cátalogo`);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const distanceFromBottom = documentHeight - (scrollY + windowHeight);

      if (scrollY > 300 && distanceFromBottom > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleShare = () => {
    const whatsappUrl = `https://wa.me/524773059542?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <BtnFloatingContainer
          as={motion.div}
          initial={{ opacity: 0, scale: 0 }}
          animate={{ opacity: 1, scale: 1 }}
          whileHover={{ scale: 1.2 }}
          whileTap={{ scale: 0.8 }}
          exit={{ opacity: 0, scale: 0 }}
          transition={{ duration: 0.4,
                scale: { type: "spring", visualDuration: 0.4, bounce: 0.5 }, }}
        >
          <motion.img
            src={imgWhatsApp}
            alt="WhatsAppIcon"
            onClick={handleShare}
          />
        </BtnFloatingContainer>
      )}
    </AnimatePresence>
  );
};

const BtnFloatingContainer = styled.div`
  background-color: #25d366;
  position: fixed;
  z-index: 10;
  bottom: 0;
  right: 0;
  border-radius: 100%;
  padding: 10px;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);

  img {
    object-fit: cover;
    height: 50px;
    filter: invert(100%);
  }
`;

export default BtnContactWhatsAppFloating;